import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import pop from '@/mixin/pop';
import { delQueStr } from '@tencent/vft-common/util';
import MagicService from '../../../service/magic';
export default {
  mixins: [pop],
  data: function data() {
    return {
      masterInfo: null
    };
  },
  components: {
    Avatar: Avatar
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.getMasterInfo();
      }
    }
  },
  methods: {
    clearKey: function clearKey() {
      var _window = window,
          location = _window.location,
          history = _window.history;

      try {
        var url = location.href;
        var keys = ['token'];
        keys.forEach(function (key) {
          url = delQueStr(url, key);
        });

        if (history.replaceState) {
          history.replaceState(null, document.title, url);
        }
      } catch (e) {
        console.error(e);
      }
    },
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    },
    getMasterInfo: function getMasterInfo() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return MagicService.getMasterInfo({
                  token: _this.token
                }).catch(function (e) {
                  _this.toast("\u670D\u52A1\u5668\u5F00\u5C0F\u5DEE\u4E86\u3010".concat(e.code, "\u3011"));

                  return Promise.reject(e);
                });

              case 2:
                res = _context.sent;

                if (!(res.remain_num === 0)) {
                  _context.next = 8;
                  break;
                }

                _this.clearKey();

                _this.toast('哎呀，来迟了，您的票已经被抢光了');

                _this.close();

                return _context.abrupt("return");

              case 8:
                _this.masterInfo = res;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    receiveTicket: function receiveTicket() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return MagicService.receiveTicket({
                  token: _this2.token
                }).catch(function (e) {
                  var code = e.code;

                  if (code === -1005) {
                    _this2.loginTips();
                  } else if (code === -1007) {
                    _this2.toast('活动已经结束了');
                  } else if (code === -1022) {
                    _this2.toast('来晚了，套票已经被领完了');
                  } else if (code === -1020) {
                    _this2.toast('你已经拥有套票了，无法领取');
                  } else {
                    _this2.toast('啊哦，服务器开小差了，请稍后再试~');
                  }

                  _this2.clearKey();

                  _this2.close();

                  return Promise.reject(e);
                });

              case 2:
                _this2.clearKey();

                _this2.close();

                _this2.launchShare();

                _this2.eventBus.$emit('refreshTicketInfo');

                _this2.eventBus.$emit('bookAct');

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    launchShare: function launchShare() {
      this.eventBus.$emit('launchShare', {
        mode: 'lq',
        label: '已领取'
      });
    }
  },
  computed: {}
};